import type { roles as en } from '@/i18n/locales/en/roles';
import type { Translation } from '@/i18n/types';

export const roles: Translation<typeof en> = {
  form: {
    person: 'Persona',
    choose: 'Elige…',
    grant: 'Conceder {{label}}',
    revoke: 'Revocar {{label}}',
    back: 'Volver',
  },
  company: {
    title: 'Administradores de la empresa',
    lead: 'Un administrador de empresa gestiona la información propia de la empresa, sus departamentos, miembros y aprovisionamiento. Conceder y revocar quedan auditados.',
    label: 'administrador de la empresa',
    rowsLabel: 'los miembros de la empresa',
  },
  department: {
    title: 'Administradores de departamento (entrenador)',
    lead: 'Un administrador de departamento lee los miembros y agregados de este departamento y, según la regla de acceso individual, las estadísticas individuales que cubre su base de consentimiento. Conceder y revocar quedan auditados.',
    label: 'administrador de departamento',
    rowsLabel: 'los miembros del departamento',
  },
  admins: {
    title: 'Administradores de la plataforma',
    lead: 'Un administrador de la plataforma tiene toda la autoridad, en cualquier ámbito. El objetivo de un nombramiento debe tener acceso propio y ser una identidad principal; el último administrador no puede ser retirado.',
    name: 'Nombre',
    email: 'Correo electrónico',
    retire: 'Retirar',
    rowsLabel: 'los administradores',
    searchPeople: 'Buscar personas',
    searchPlaceholder: 'Nombre o correo electrónico',
    person: 'Persona',
    choose: 'Elige…',
    noEligible: 'Ninguna persona elegible coincide — necesitan tener acceso propio.',
    appoint: 'Nombrar',
    usersLabel: 'los usuarios de la plataforma',
  },
};
